export default __webpack_public_path__ + "static/media/aerated-concrete.457a73b6.svg";